import { render } from "./FooterScreen.vue?vue&type=template&id=a5a2c8c4&scoped=true"
import script from "./FooterScreen.vue?vue&type=script&lang=js"
export * from "./FooterScreen.vue?vue&type=script&lang=js"

import "./FooterScreen.vue?vue&type=style&index=0&id=a5a2c8c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a2c8c4"]])

export default __exports__